import axios from 'axios';
import Auth from "@aws-amplify/auth";
import { autoLogout } from './utils/autoLogout';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  async (config) => {
    try {
      const session = await Auth.currentSession();
      const token = session.getIdToken().getJwtToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      // Cognito セッション切れ（更新トークン期限切れ等）を検知
      alert('Your login session has expired. Please log in again.');
      autoLogout();
      return Promise.reject(error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const http = { api: api };

export default http;
